import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PRODUCTION_ORIGIN = "https://aksgyrmnkl.com";

/**
 * This is a CRA SPA served from a single static index.html - without this, the
 * <link rel="canonical"> written at build time in public/index.html (pointing to the
 * homepage, "https://aksgyrmnkl.com/") would stay stuck on "/" for every route
 * (e.g. /kategori/daire, /hakkimizda), incorrectly telling search engines those pages
 * are duplicates of the homepage.
 *
 * This updates the href of the SAME existing <link rel="canonical"> tag on every route
 * change - it never creates a second tag - so there is always exactly ONE canonical tag
 * in <head>, always matching the current path. No library needed: react-router's
 * useLocation (already a project dependency) is enough. Query strings/filters are
 * intentionally excluded so canonical always points at the clean path.
 */
const CanonicalManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname === "/" ? "/" : location.pathname.replace(/\/+$/, "");
    const canonicalUrl = `${PRODUCTION_ORIGIN}${path}`;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);
  }, [location.pathname]);

  return null;
};

export default CanonicalManager;
